import _ from 'lodash';
import React, { useCallback, useContext, useState, useEffect } from 'react';

import { BreakpointTrackerContext } from '@jutro/layout'
import { TranslatorContext } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

import { AgentRegistrationService } from '../../../../capabilities/ent-capability-agentregistration/index.js';
import metadata from './Activation.metadata.json5';
import styles from './Activation.module.scss';
import messages from './Activation.messages.js';
import UWCompanyUtil from '../../utils/UWCompanyUtil_TWIA.js';


function ActivationPage(props) {
  const { id } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const [showErrors, setShowErrors] = useState(false);
  const [loading, setShowLoading] = useState(true);
  const [isExpired, setIsExpired] = useState(true);
  const { showAlert } = useModal();
  const translator = useContext(TranslatorContext);
  const { onValidate, isComponentValid } = useValidation(id);
  const viewModelService = useContext(ViewModelServiceContext);
  const [tdiAgencySearchVM, setTDIAgencySearchVM] = useState();
  const { refreshData } = useDataRefresh();

  useEffect(() => {
     if (viewModelService && !tdiAgencySearchVM) {
         const searchParams = new URL(window.location.href).searchParams;
         const token = searchParams && searchParams.get('token');
         const vmInitial = {
             "isAgencyVerification": true,
             "isSSN": searchParams && searchParams.get('aType') !== 'e',
             "registrationToken": token,
             "uwcompany": searchParams && searchParams.get('company')
         };
         const dto = 'org.tfpa.edge.capabilities.agent.dto.TDIAgencySearchDTO';
         const viewModel = viewModelService.create(vmInitial, 'pc', dto);
         setTDIAgencySearchVM(viewModel);
         // US26505 if registration is expired, notify user
         if (token) {
             AgentRegistrationService.isExpired(token
             ).then(response => {
                 setIsExpired(response);
                 setShowLoading(false);
             }).catch(err => {
                 setShowLoading(false);
             });
         } else {
             setShowLoading(false);
         }
     }
  }, [viewModelService]);

  const writeValue = useCallback((value, path) => {
        _.set(tdiAgencySearchVM, `${path}.value`, value);
        setTDIAgencySearchVM(tdiAgencySearchVM);
        refreshData();
    },
    [tdiAgencySearchVM, setTDIAgencySearchVM, refreshData]
  );

  const createActivation = useCallback(() => {
    if (!isComponentValid) {
        setShowErrors(true);
        return false;
    }

    setShowLoading(true);
    AgentRegistrationService.createActivationLink(tdiAgencySearchVM.value
    ).then(response => {
      window.location.href = response;
    }).catch(err => {
      const errorCode = _.get(err, 'data.appErrorCode');
      const body = errorCode === 5220 ?
       messages.activationLockoutBody : messages.activationFailedBody; 
      console.log(`errorCode${errorCode}, body:${body}`);
        showAlert({
            title: messages.activationFailedTitle,
            message: body,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
        }).catch(_.noop);
        setShowLoading(false);
    });
  }, [isComponentValid, tdiAgencySearchVM]);

  const overrideProps = {
    '@field': {
      labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
      showErrors,
      showRequired: true
    },
    activationInstructions: {
        visible: !isExpired
    },
    activationContainer: {
        visible: !loading && !isExpired
    },
    ssn: {
        visible: _.get(tdiAgencySearchVM, 'isSSN.value')
    },
    ein: {
        visible: !_.get(tdiAgencySearchVM, 'isSSN.value')
    },
    uWCompany: {
        disabled: _.get(tdiAgencySearchVM, 'uwcompany.value')
    },
    loadingIndicator: {
        visible: loading
    },
    activationTitle: {
        content: UWCompanyUtil.isTWIACompany(_.get(tdiAgencySearchVM, 'uwcompany')) ? translator(messages.activationTitleTwia) :  translator(messages.activationTitleTfpa)
    },
    activationExpired: {
        visible: !loading && isExpired
    },
    newRegistrationLink: {
        to: `/new-agent`,
        content: translator(messages.newRegistrationLink),
    }
  };

  const resolvers = {
    resolveClassNameMap: styles,
    resolveCallbackMap: {
        createActivation: createActivation
    }
  }

  return (
    <ViewModelForm
      uiProps={metadata.pageContent}
      model={tdiAgencySearchVM}
      overrideProps={overrideProps}
      classNameMap={resolvers.resolveClassNameMap}
      callbackMap={resolvers.resolveCallbackMap}
      componentMap={resolvers.resolveComponentMap}
      onValidationChange={onValidate}
      onValueChange={writeValue}
    />
  )
}

export default ActivationPage;
